import axios from "axios";
import { authenticationService, IWMService , geteWayAuctionServer, auctionService } from "./config";

function getAuthURL() {
  return `${authenticationService.baseURL}`;
}

function getAuth() {
  let Auth = axios.create(authenticationService);
  const token = localStorage.getItem("CCXT");
  if (token) Auth.defaults.headers.common["X-Authentication-Token"] = token;
  return Auth;
}

function getIWMURL() {
  return `${IWMService.baseURL}`;
}

function getIWM() {
  let Auth = axios.create(IWMService);
  const IWMToken = localStorage.getItem("__wasteknot");

  if (IWMToken)
    Auth.defaults.headers.common["X-Authentication-Token"] = IWMToken;
  return Auth;
}


function getAuctionUrl() {
  return `${auctionService.baseURL}`;
}

function getAuction() {
  let Auction = axios.create(auctionService);
  const auctionToken = localStorage.getItem("__wasteknot");

  if (auctionToken)
    Auction.defaults.headers.common["X-Authentication-Token"] = auctionToken;
  return Auction;
}

export const Auth = getAuth();
export const AuthURL = getAuthURL();
export const IWM = getIWM();
export const IWMURL = getIWMURL();

export const auction = getAuction();
export const getAuctionURL = getAuctionUrl();